import { selectStandardProps } from "@/utils/componentUtils";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import type { UUID } from "../../../../typings/global";
import { BooleanFilter } from "../../../enums";

type Props = {
  value?: UUID;
  allowClear?: boolean;
  onChange?: (data: UUID) => void;
  disabled?: boolean;
  translationPath: string;
};

export const BooleanFilterSelect = ({ value, allowClear, onChange, disabled, translationPath }: Props) => {
  const { t } = useTranslation();

  return (
    <Select
      {...selectStandardProps}
      allowClear={allowClear}
      value={value}
      options={Object.values(BooleanFilter).map((item) => ({
        value: item,
        label: t(`${translationPath}.${item}`),
      }))}
      onChange={onChange}
      disabled={disabled}
    />
  );
};
